<div class="memberResources">
    <section class="page-container">
        <div class="container">
            <div class="row mb-4">
                <div class="col-12">
                    <div class="breadcrumbTrail">
                        <a [routerLink]="['/public/resources']">Member Resources & Savings</a>
                        <span class="breadcrumbLevel"><i class="fa-regular fa-angle-right"></i></span>
                        <span class="current">Resource</span>
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col">
                    <h1 class="resourceName mb-0">{{resourcePage.pageName}}</h1>
                    <span class="resourceDate">{{resourcePage.lastUpdated}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-8">

                    <!-- start wysiwyg content-->
                    <div class="articleContent">
                        <div [innerHTML]="safePageContent"></div>
                    </div>
                    <!-- end wysiwyg content-->

                </div>
                <div class="col-md-4">
                    <div class="supportingFiles ms-4">
                        <div class="moreArticlesHeading">
                            <h3>Supporting Files</h3>
                            <div class="styledUnderline"></div>
                        </div>
                        <div class="attachmentBlock" *ngFor="let attachment of resourcePage.attachments; index as ind" (click)="DownloadAttachment(ind)">
                            <div class="fileType">
                                <i class="fa-regular" [ngClass]="CommonLibrary.GetFileIconClass(attachment.type)"></i>
                            </div>
                            <div class="fileInfo">
                                <a href="javascript:void(0)" title="download a supporting file" class="fileTitle">
                                    {{attachment.name}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>